import { Themes_Theme_Entry } from '@wwtr/generated';

export const getIcon = (item: Themes_Theme_Entry): string => {
  if (item.icon.url !== null) return item.icon.url;
  return '/assets/images/open-folder.svg';
};
